"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
exports.__esModule = true;
var WebExtractorWrapper = function () {
  function WebExtractorWrapper() {}
  WebExtractorWrapper.toECField = function (selector, fieldName, regExp, regExpReplace, required, ec) {
    return {
      id: ec ? ec.uuid() : extractorContext.uuid(),
      name: fieldName,
      type: "AUTO",
      selector: selector.css ? [[selector.css]] : undefined,
      xpath: selector.xpath,
      required: required,
      captureLink: false,
      ranking: 0,
      microPath: selector.microPath
    };
  };
  WebExtractorWrapper.extract = function (arr, rowSelector, ec) {
    return __awaiter(this, void 0, void 0, function () {
      var fieldConfig, context, returnedValue, responses, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            fieldConfig = {
              fields: arr.filter(function (q) {
                return q.selector && (q.selector.css || q.selector.xpath || q.selector.microPath);
              }).map(function (q) {
                return WebExtractorWrapper.toECField(q.selector, q.fieldName, q.regExp, q.regExpReplace, q.required);
              }),
              singleRecord: !rowSelector,
              recordXPath: rowSelector && rowSelector.xpath,
              regionsSelector: rowSelector && rowSelector.css ? [Array.isArray(rowSelector.css) ? rowSelector.css : [rowSelector.css]] : undefined
            };
            if (fieldConfig.fields.length === 0) {
              return [2, undefined];
            }
            context = ec ? ec : extractorContext;
            return [4, context.extractData(fieldConfig)];
          case 1:
            returnedValue = _a.sent();
            if (!returnedValue || !returnedValue.length) {
              return [2, undefined];
            }
            responses = [];
            returnedValue[0].group.forEach(function (q) {
              return responses.push(q);
            });
            response = responses.map(function (q) {
              return Object.keys(q).reduce(function (obj, key) {
                var val = q[key] && q[key].map(function (w) {
                  return w.text || w.href || w.src || w.alt || "";
                });
                var field = arr.find(function (w) {
                  return w.fieldName === key;
                });
                if (!field) {
                  return obj;
                }
                if (val === undefined) {
                  return obj;
                }
                var mapFunction = function mapFunction(w) {
                  if (field.regExp) {
                    return WebExtractorWrapper.applyRe({
                      re: new RegExp(field.regExp, "g"),
                      replace: field.regExpReplace
                    }, w);
                  }
                  return w;
                };
                var regexedVal = context.lodash.flatten(val.map(mapFunction));
                obj[key] = regexedVal;
                return obj;
              }, {});
            });
            return [2, response];
        }
      });
    });
  };
  WebExtractorWrapper.applyRe = function (re, text) {
    var m = text.match(re.re);
    if (m) {
      return m.map(function (s) {
        return re.replace ? s.replace(re.re, re.replace) : s;
      });
    }
    return [""];
  };
  return WebExtractorWrapper;
}();
exports["default"] = WebExtractorWrapper;